import moment from "moment/moment";

export default class UserProfile {
    private readonly _consumer: string;
    private readonly _consumerType: string;
    private readonly _consumerTypeSlug: string | null;
    private readonly _country: string | null;
    private readonly _degreeId: string | null;
    private readonly _degreeName: string | null;
    private readonly _fieldOfStudy: string | null;
    private readonly _graduateDate: string | null;
    private readonly _schoolName: string | null;
    private readonly _schoolId: string | null;

    constructor({
      consumer,
      consumerType,
      consumerTypeSlug,
      country,
      degree,
      fieldOfStudy,
      graduateDate,
      school,
    }) {
        this._consumer = consumer;
        this._consumerType = consumerType;
        this._consumerTypeSlug = consumerTypeSlug;
        this._country = country;
        this._degreeId = degree ? degree.id : null;
        this._degreeName = degree? degree.attributes.standardName : null;
        this._fieldOfStudy = fieldOfStudy;
        this._graduateDate = graduateDate ? moment(graduateDate).utc(true).format() : '';
        this._schoolName = school ? school.attributes.name : null;
        this._schoolId = school ? school.id : null;
    }

    get consumer(): string | null {
      return this._consumer;
    }

    get consumerType(): string | null {
        return this._consumerType;
    }

    get consumerTypeSlug(): string | null {
      return this._consumerTypeSlug;
    }

    get country(): string | null {
      return this._country;
    }

    get degreeId(): string | null {
      return this._degreeId;
    }

    get degreeName(): string | null {
      return this._degreeName;
    }

    get fieldOfStudy(): string | null {
      return this._fieldOfStudy;
    }

    get graduateDate(): string | null {
      return this._graduateDate;
    }

    get schoolName(): string | null {
      return this._schoolName;
    }
    get schoolId(): string | null {
      return this._schoolId;
    }
}
